export default __webpack_public_path__ + "static/media/Protector 1.6 x 1.fcb823fd.png";